import { useDrawDetails } from "../../context/draw-details";
import styles from "./styles";

const eng = {
  ldp_draw_status_live: "DRAW OPENS SOON",
  ldp_draw_status_drawn: "GOOD LUCK",
  ldp_draw_status_closed: "MORE COMING SOON...",
  ldp_draw_status_complete: "MORE COMING SOON...",
  ldp_draw_status_entered: "GOOD LUCK",
};

export const DrawStatus = () => {
  const [state] = useDrawDetails();

  const {
    drawDetails: { status },
  } = state;

  return (
    <div className={styles.wrapper}>
      <div className={styles.status}>{eng[`ldp_draw_status_${status}`]}</div>
    </div>
  );
};
